<template>
  <div
    class="Navigation"
    :class="{ active }">
    <nav @click="$emit('navigated')">
      <router-link to="/">
        <span class="icon"><Icon name="home" /></span>
        <span class="label">Dashboard</span>
      </router-link>

      <router-link to="/bookings">
        <span class="icon"><Icon name="calendar" /></span>
        <span class="label">Bookings</span>
      </router-link>

      <router-link to="/reports">
        <span class="icon"><Icon name="report" /></span>
        <span class="label">Reports</span>
      </router-link>

      <router-link to="/settings">
        <span class="icon"><Icon name="settings" /></span>
        <span class="label">Settings</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";

$width: 289px;

.Navigation {
  position: fixed;
  height: 100%;
  width: $width;
  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);
  z-index: 99999;

  @include phone {
    transition: left 0.2s ease-in-out;
    position: absolute;
    left: -$width;
    height: 100%;

    &.active {
      left: 0;
    }
  }

  nav {
    display: flex;
    flex-direction: column;
    background-color: white;
    height: 100%;

    a,
    a:visited {
      padding: 1em;
      display: flex;
      align-items: baseline;
      opacity: 0.5;
      color: var(--midnight-blue);
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);

      &.router-link-exact-active {
        padding: 1em;
        opacity: 0.92;
        background-color: rgba(71, 39, 170, 0.19);
        color: var(--blue-purple);

        border: none;
      }

      .label {
        padding-left: 1em;
      }
    }
  }
}
</style>
